import React from 'react'
import moment from 'moment-timezone'
import { uuid } from 'uuidv4'
import { Avatar, Col, Row, Tag } from 'antd'
import env from 'env'

interface VariantNameAndAvatarProps {
  id: string
  name: string
  testId: string | undefined
  options: string[]
}

const VariantNameAndAvatar = ({
  id,
  name,
  testId,
  options
}: VariantNameAndAvatarProps) => {
  const imageUrl = `https://gear.${
    env.ASSET_HOST
  }/assets/variant/${id}?size=original&${moment().unix()}`

  return (
    <Row align='middle' gutter={[8]} className='_mb-0'>
      <Col>
        <Avatar size={30} shape='square' src={imageUrl} />
      </Col>
      {!!(options || []).length ? (
        <Col span={18}>
          <Row className='_mb-0'>
            <Col>
              <span data-testid={testId}>{name}</span>
            </Col>
          </Row>
          <Row className='_mb-0' gutter={[8, 8]}>
            {options.map((option) => (
              <Tag className='-basic' key={uuid()}>
                {option}
              </Tag>
            ))}
          </Row>
        </Col>
      ) : (
        <Col>
          <span data-testid={testId}>{name}</span>
        </Col>
      )}
    </Row>
  )
}

export default VariantNameAndAvatar
